import {
  Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { taskHistoryRequest } from '../../store/actions';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import Paper from "@material-ui/core/Paper";
import AccountCircleTwoToneIcon from '@material-ui/icons/AccountCircleTwoTone';
import ChangeIcon from 'src/components/ChangeIcon';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0,
    minHeight: 430
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  divider: {
    backgroundColor: '#1D3343'
  }
}));

function Tarihce({
  className,
  ReceiptNo,
  taskHistoryReducer,
  taskHistoryRequest
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');

  useEffect(() => {
    taskHistoryRequest(ReceiptNo);
  }, [taskHistoryRequest, ReceiptNo]);

  return (
    <>
    {taskHistoryReducer.loading ? (
      <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
    ) : (
      <div />
    )}
    <Timeline align="alternate">

      {taskHistoryReducer.data.map((log, index) => 
     
          <TimelineItem >
            <TimelineOppositeContent>
              <Typography variant="body2" color="textSecondary"
                className={classes.inline}
              >
                {log.GUN + " " + log.AY.substring(0, 3) + " " + log.YIL + " " + "-" + " " + log.SAAT}
              </Typography>
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot color="inherit">
              <ChangeIcon MobilStatusId={log.MobileStatusId} />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Paper elevation={3} className={classes.paper}>
                <Typography variant="h6" component="h1"
                  className={classes.inline}
                  color="textPrimary"
                > <h2><b> {log.WorkOrderId + ' - ' + log.DURUM} </b></h2>
                </Typography>
                <Typography>
                  <b>{t('lblUpdateUserId')}:</b> {log.ISLEM_YAPAN}
                  <br></br>
                  <b>{t('lblOrganization')}:</b> {log.KULLANICI}
                  <br></br>
                  <b>{t('lblNote')}:</b> {log.GPSNote}
                  <br></br>
                  {log.CancellationReasonId>0 && log.MobileStatusId===5 ?(
                    <div>
                      <b>{t('CancellationReason')} :</b>
                      {log.CancellationReason.toString()}
                    </div>
                  ): ''
                            }
                  {log.CancellationReasonId>0 && log.MobileStatusId===5 ?(
                    <div>
                      <b>{t('CancellationNote')} :</b>
                      {log.CancellationNote.toString()}
                    </div>
                  ):  ''
                  }
                </Typography>
              </Paper>
            </TimelineContent>

          </TimelineItem> 
    )}
    </Timeline>
  </>




);
}

Tarihce.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    taskHistoryReducer: state.taskHistoryReducer
  }),
  { taskHistoryRequest }
)(Tarihce);
